import { isFulfilled } from "@reduxjs/toolkit";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../app/hooks";
import CommentInputBox from "../../../common/components/functional/comments/CommentInputBox";
import {
  AddOrderBundleComment as AddOrderBundleCommentCommand,
  OrderBundleCommentAdded,
} from "../orderAPI";
import { addOrderBundleComment } from "../orderBundleCommentsSlice";

type Props = {
  bundleId: string;
  firstName: string;
  lastName: string;
  onCommentAdded: (
    id: string,
    version: number,
    payload: OrderBundleCommentAdded,
  ) => void;
};

const AddOrderBundleCommentComponent = ({
  bundleId,
  firstName,
  lastName,
  onCommentAdded,
}: Props) => {
  const { t } = useTranslation("order");
  const dispatch = useAppDispatch();

  const handleSend = async (text: string) => {
    const payload: AddOrderBundleCommentCommand = {
      bundleId,
      comment: text,
    };
    const action = await dispatch(addOrderBundleComment(payload));
    if (isFulfilled(action)) {
      const event = action.payload[0];
      onCommentAdded(event.id, event.version, event.payload);
    }
  };

  return (
    <CommentInputBox
      firstName={firstName}
      lastName={lastName}
      placeholder={t("addComment")}
      onSend={handleSend}
    />
  );
};

export default AddOrderBundleCommentComponent;
